export const AssistantStore = {
  Sidebar: {
    Open: false
  },

  Sessions: {
    Recent: {
      Data   : [],
      Loading: false
    },
    All: {
      Data   : [],
      Loading: false
    }
  },

  SelectedSession: {
    Data: null
  },

  Messages: {
    Data       : [],
    Loading    : false,
    AutoScroll : true,
    SendEnabled: true
  },

  Streaming: {
    Active          : false,
    AnimationActive : false,
    DisplayedContent: '',
    StopRequested   : false,
    StreamId        : null
  },

  Editing: {
    Active: false
  },

  Socket: {
    Connected: false
  },

  Greeting: {
    Data   : null,
    Loading: false
  },

  Suggestions: {
    Data   : [],
    Loading: false,
    Page   : null
  }
}
